/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => $(document)
  .off("keyup", ".js-group-search", App.groups.search)
  .on("keyup", ".js-group-search", App.groups.search)

  .off("click", ".js-autoresponder-toggle", App.groups.autoresponder_toggled)
  .on("click", ".js-autoresponder-toggle", App.groups.autoresponder_toggled)

  .off("click", ".js-retain-contacts-toggle", App.groups.retain_contacts_toggled)
  .on("click", ".js-retain-contacts-toggle", App.groups.retain_contacts_toggled)

  .off("click", ".js-send-update-links-toggle", App.groups.send_update_links_toggled)
  .on("click", ".js-send-update-links-toggle", App.groups.send_update_links_toggled)

  .off("change", ".js-group-switcher", App.groups.switched)
  .on("change", ".js-group-switcher", App.groups.switched));


App.modal_ready(() => App.groups.set_retain_contacts_dependencies(
  $(".js-autoresponder-toggle").is(":not(:checked)") || $(".js-retain-contacts-toggle").is(":checked")
  ));


App.groups = {

  // Are we currently viewing the all group?
  is_all_group() {
    return this.all_group_id() === this.current_id();
  },


  all_group_id() {
    return parseInt($("meta[name='all-group-id']").attr("content"), 10);
  },


  // Return the current group id
  current_id() {
    let matches;
    const id = (matches = location.pathname.match(/groups\/(\d)\//i)) ?
            matches[1]
          :
            App.groups.all_group_id();
    return parseInt(id, 10);
  },


  created(html) {
    $(".js-group-boxes").append(html);
    App.groups.sort();
    return App.modals.close_all();
  },


  updated(html) {
    const id = $(html).attr("data-id");
    $(`.js-group-box[data-id='${id}']`).replaceWith(html);
    App.groups.sort();
    return App.modals.close_all();
  },


  destroyed(group_id) {
    const id = $(html).attr("data-id");
    $(`.js-group-box[data-id='${id}']`).fadeOut();
    return App.modals.close_all();
  },


  sort() {
    return tinysort(".js-group-boxes .js-group-box", { data: "name" });
  },


  search(evt) {
    const val = $(".js-group-search").val().toLowerCase();
    if (val) {
      return $(".js-name").each(function() {
        if ($(this).text().toLowerCase().search(val) > -1) {
          return $(this).closest(".js-group").show();
        } else {
          return $(this).closest(".js-group").hide();
        }
      });

    } else {
      return $(".js-group").show();
    }
  },


  autoresponder_toggled(evt) {
    if (this.checked) {
      $(".js-autoresponder-fields").addClass("is-active");
      return App.groups.set_retain_contacts_dependencies($(".js-retain-contacts-toggle").is(":checked"));
    } else {
      $(".js-autoresponder-fields").removeClass("is-active");
      return App.groups.set_retain_contacts_dependencies(true);
    }
  },


  retain_contacts_toggled(evt) {
    return App.groups.set_retain_contacts_dependencies(this.checked);
  },


  set_retain_contacts_dependencies(retain_contacts) {
    const parent = $(".js-depends-on-retaining-contacts");
    if (retain_contacts) {
      parent.removeClass("disabled");
      parent.find("input").prop("disabled", false);
      $(".js-show-if-disabled").addClass("hidden");
      return App.groups.set_send_update_links_dependencies($(".js-send-update-links-toggle").is(":checked"));
    } else {
      parent.addClass("disabled");
      parent.find("input").prop("disabled", true);
      return $(".js-show-if-disabled").removeClass("hidden");
    }
  },


  send_update_links_toggled(evt) {
    return App.groups.set_send_update_links_dependencies(this.checked);
  },


  set_send_update_links_dependencies(send_updates) {
    const parent = $(".js-send-name-requests-wrapper");
    if (send_updates) {
      parent.removeClass("disabled");
      return parent.find("input").prop("disabled", false);
    } else {
      parent.addClass("disabled");
      return parent.find("input").prop("disabled", true);
    }
  },


  switched(evt) {
    let url;
    const group_id = $(this).val();
    const controller = $(this).data("controller");
    const params = new URLSearchParams(location.search);

    if (group_id === "ungrouped") {
      params.set("ungrouped", true);
      url = "/contact_memberships.js?" + params.toString();
    } else {
      params.delete("ungrouped");
      url = `/groups/${group_id}/${controller}.js?` + params.toString();
    }

    window.busy_timer = window.setTimeout(App.busy.start, 500);

    $.get(url)
      .always(function() {
        window.clearTimeout(window.busy_timer);
        return App.busy.done();
    });

    if (group_id !== "ungrouped") {
      $(".js-href-with-group-id").each(function() {
        const $link = $(this);
        const href = $link.attr("href").replace(/.+:\/\/[^\/]+/, "");

        const new_href = /groups\/\d+/.test(href) ?
                      href.replace(/groups\/\d+/, `groups/${group_id}`)
                    :
                      `/groups/${group_id}${href}`;

        return $link.attr("href", new_href);
      });

      return $(".js-href-with-group-param").each(function() {
        const $link = $(this);
        const new_href = new URL($link.attr("href"));
        new_href.searchParams.set("group_id", group_id);
        return $link.attr("href", new_href.toString());
      });
    }
  }
};
